import { z } from 'zod';

/**
 * Általános típusok az API-felületen.
 * UUID v7 (időrendes) az új entitásoknál — sortolt, indexbarát.
 */

export const UuidSchema = z.string().uuid();
export type Uuid = z.infer<typeof UuidSchema>;

export const IsoDateTimeSchema = z.string().datetime({ offset: true });
export type IsoDateTime = z.infer<typeof IsoDateTimeSchema>;

export const TenantIdSchema = z.string().min(1).max(64).regex(/^[a-z0-9][a-z0-9-]{0,62}[a-z0-9]$/);
export type TenantId = z.infer<typeof TenantIdSchema>;

export const LanguageCodeSchema = z
  .string()
  .min(2)
  .max(8)
  .regex(/^[a-z]{2,3}(-[A-Z]{2})?$/, 'BCP47 nyelvi kód kell (pl. hu, en-US)');
export type LanguageCode = z.infer<typeof LanguageCodeSchema>;

export const PageInfoSchema = z.object({
  cursor: z.string().nullable(),
  hasMore: z.boolean(),
  // A backend `total: null`-t küld, ha nem számolt össze — ez megengedett.
  total: z.number().int().nonnegative().nullable().optional(),
});
export type PageInfo = z.infer<typeof PageInfoSchema>;

export function paginated<T extends z.ZodTypeAny>(item: T) {
  return z.object({
    data: z.array(item),
    page: PageInfoSchema,
  });
}

export const SortDirSchema = z.enum(['asc', 'desc']);
export type SortDir = z.infer<typeof SortDirSchema>;
